module.exports = __webpack_public_path__ + "static/media/twitterX-disabled.dbe0a65a.svg";